
export enum Gender {
    Male = 0,
    Female = 1
}

export enum PersonType {
    Student = 0,
    Employee = 1,
    Parent = 2
}

export class Person {
    public person_id: number;
    public first_name: string;
    public middle_name: string;
    public last_name: string;
    public full_name: string;
    public mobile_number: string;
    public land_line_number: string;
    public email_address: string;
    public image_key: string;
    public gender: Gender;
    public permanent_address_one: string;
    public permanent_address_two: string;
    public permanent_city: string;
    public permanent_district: string;
    public permanent_state: string;
    public permanent_zip_code: string;
    public permanent_country: string;
    public local_address_one: string;
    public local_address_two: string;
    public local_city: string;
    public local_district: string;
    public local_state: string;
    public local_zip_code: string;
    public local_country: string;
    public person_guid_blowfish_encrypted: string;
    public person_type: PersonType;
}
